<template>
    <div id="app" class="container">
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        name: 'login',
        mounted(){
        },
        methods: {}
    }
</script>
<style>
    @import "assets/styles/space.css";
    @import "assets/styles/font.css";

    body,
    html {
        padding: 0;
        margin: 0;
        overflow-y: auto;
        height: 100%;
    }

    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        height: 100%;
    }

    body {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .ql-picker-label:focus {
        outline: none;
        border: 1px solid yellow;
    }
</style>
